<template>
  <div>
  
    <article 
      v-if="!loading && productInventory.length == 0" 
      class="message is-info is-fullwidth">
      <div class="message-body">
        There is no inventory.
      </div>
    </article>

    <table v-else class="table is-fullwidth is-hoverable has-small-font">

      <thead>
        <tr>
          <th 
            v-for="(header, headerIndex) in headers"
            :key="headerIndex">
            {{ header }}
          </th>
        </tr>
      </thead>

      <tbody>
        <template 
          v-for="inventoryItem in productInventory">
          <tr
            class="v-centered subheader"
            v-if="inventoryItem.product_master"
            :key="inventoryItem.id">

            <td>
              {{ inventoryItem.product_master.name }}
            </td>
            <td>
              <span v-if="inventoryItem.product_master.product_category">
                {{ inventoryItem.product_master.product_category.category }}
              </span>
            </td>
            <td class="text--nowrap">
              <template 
                v-if="inventoryItem.product_master.product_category.has_dimensions">
                {{ lwt(inventoryItem.stocking_unit) }}
              </template>
              <span>
                {{ inventoryItem.product_master.size }}
              </span>
            </td>
            <td class="has-text-weight-semibold">
              {{ inventoryItem.total_qty }}
            </td>
            <td>
              {{ inventoryItem.qty_assigned }}
            </td>
            <td>
              {{ inventoryItem.qty_available }}
            </td>
            <td>
              {{ inventoryItem.total_value | currency }}
            </td>
            <td>
              {{ inventoryItem.avg_price_unit | currency }}
            </td>
            <td>
              <div class="buttons buttons-right">
                <button 
                  @click.stop="modifyItem(inventoryItem, 'transfer')"
                  class="button has-text-grey is-small">
                  <span class="icon">
                    <i class="fas fa-exchange-alt"></i>
                  </span>
                  <span>Transfer</span>
                </button>
              </div>
            </td>
          </tr>

          <tr 
            v-if="inventoryItem.stocking_unit && inventoryItem.stocking_unit.storage_unit.length > 0" 
            :key="inventoryItem.id + '-warehouse-locations'">
            <td :colspan="headers.length">
              <table class="table is-fullwidth">
                <thead> 
                  <tr class="v-centered is-narrow has-background-light has-tiny-font">
                    <th 
                      v-for="(header, headerIndex) in locationHeaders"
                      :key="headerIndex">
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    class="has-background-light v-centered"
                    v-for="storageUnit in inventoryItem.stocking_unit.storage_unit"
                    :key="storageUnit.id">
                    <template v-if="storageUnit.storage && storageUnit.storage.warehouse_location">
                      <td>
                        {{ storageUnit.storage.warehouse_location.warehouse.warehouse_name }}
                      </td>
                      <td>
                        {{ storageUnit.storage.warehouse_location.warehouse.warehouse_code }}
                      </td>
                      <td>
                        {{ storageUnit.storage.warehouse_location.location_name }}
                      </td>
                      <td>
                        {{ storageUnit.storage.warehouse_location.location_name }}
                      </td>
                    </template>
                    <td colspan="4" v-else class="has-text-grey-light">
                        No warehouse location information
                    </td>
                    <td>
                      {{ storageUnit.qty }}
                    </td>
                    <td>
                      <div class="buttons buttons-right">
                        <button
                          @click.stop="
                            modifyingStorageUnit = storageUnit;
                            modifyItem(inventoryItem, 'adjust')"
                          class="button has-text-grey is-small">
                          <span class="icon">
                            <i class="fas fa-sliders-h"></i>
                          </span>
                          <span>Adjust</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </template>
      </tbody>

    </table>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <adjust-inventory-modal 
      v-if="modifyingItem"
      v-model="modifyingAction.adjust"
      :product-inventory="modifyingItem"
      :storage-unit="modifyingStorageUnit"/>

    <transfer-inventory-to-project-modal 
      v-if="modifyingItem"
      v-model="modifyingAction.transfer"
      :product-inventory="modifyingItem"/>
      
  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import AdjustInventoryModal from '@/components/inventory/AdjustInventoryModal'
import TransferInventoryToProjectModal from '@/components/inventory/TransferInventoryToProjectModal'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    VPagination, AdjustInventoryModal,
    TransferInventoryToProjectModal
  },
  data() {
    return {
      headers: [
        'Product', 'Product Category', 'Product Size', 
        'Total Quantity', 'Assigned Quantity', 'Quantity Available', 
        'Total Value', 'Average Price Per Unit', ''
      ],
      locationHeaders: [
        'Warehouse', 'Warehouse Code', 'Warehouse Location', 
        'Warehouse Location Code', 'Quantity Stored', ''
      ],
      modifyingStorageUnit: null,
      modifyingItem: null,
      modifyingAction: {
        adjust: false,
        transfer: false
      }
    }
  },
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("inventoryCentral", [
      "productInventory", "pagination", "selected", "loading", "allSelected"
    ])
  },
  watch: {
    'pagination.page'() {
      this.getInventory(this.pagination);
    }
  },
  methods: {
    ...mapActions("inventoryCentral", [
      "getInventory", "adjustInventory", "toggleAllSelected"
    ]),
    ...mapMutations("inventoryCentral", ["changePage", "toggleSelected"]),
    initialize() {
      if (this.productInventory.length == 0) {
        this.getInventory();
      }
    },
    modifyItem(item, action) {
      this.modifyingItem = item;
      this.modifyingAction[action] = true;
    },
    lwt(product) {
      if (product) {
        return `L${product.length_in_str}" x W${product.width_in_str}" x T${product.thick_in_str}"`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>